import { useEffect, useState } from "react";
import "../styles/countdown-offer.css";

const CountdownOffer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date("2025-06-28T08:30:00+07:00").getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) return;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((distance / (1000 * 60)) % 60),
        seconds: Math.floor((distance / 1000) % 60),
      });
    };

    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="countdown-offer">
      <p className="countdown-offer__text">
        🎁{" "}
        <strong className="countdown-offer__highlight">Học trải nghiệm</strong>{" "}
        ngay hôm nay
      </p>
      <p className="countdown-offer__price">
        <span className="countdown-offer__old-price">Học phí chỉ từ</span>
        <span className="countdown-offer__new-price countdown-offer__highlight">
          2.500.000đ
        </span>
      </p>

      <div className="countdown-offer__timer">
        <span className="countdown-offer__label">⏳ Hạn đăng ký còn:</span>
        <span>{timeLeft.days}d</span>
        <span>{timeLeft.hours}h</span>
        <span>{timeLeft.minutes}m</span>
        <span>{timeLeft.seconds}s</span>
      </div>
    </div>
  );
};

export default CountdownOffer;
